<script setup>
import { defineProps, defineModel, ref, computed, onMounted, onUnmounted, nextTick } from 'vue'

const value = defineModel('value')

const props = defineProps({
    values: {
        type: Array,
        required: true,
    },
    labelKey: {
        type: String,
        default: 'name'
    }
})

const isOpen = ref(false)
const dropdownRef = ref(null)
const dropdownContainerRef = ref(null)

const toggleDropdown = () => {
    isOpen.value = !isOpen.value
}

const selectItem = (item) => {
    value.value = item
    isOpen.value = false
}

const handleClickOutside = (event) => {
    const isOutsideMain = dropdownRef.value && !dropdownRef.value.contains(event.target)
    const isOutsideDropdown = dropdownContainerRef.value && !dropdownContainerRef.value.contains(event.target)

    if (isOutsideMain && isOutsideDropdown) {
        isOpen.value = false
    }
}

const displayValue = computed(() => {
    return value.value ? value.value[props.labelKey] : 'Выберите значение'
})

const dropdownStyle = computed(() => {
    if (!dropdownRef.value || !isOpen.value) return {}

    const rect = dropdownRef.value.getBoundingClientRect()
    return {
        top: `${rect.bottom}px`,
        left: `${rect.left}px`,
        width: `${rect.width}px`,
        position: 'fixed',
        'z-index': 1000
    }
})

onMounted(() => {
    document.addEventListener('click', handleClickOutside)
    document.addEventListener('scroll', handleScroll, true)
})

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside)
    document.removeEventListener('scroll', handleScroll, true)
})

const handleScroll = () => {
    if (isOpen.value) {
        isOpen.value = false
        nextTick(() => {
            isOpen.value = true
        })
    }
}
</script>

<template>
    <div class="inline-block w-fit" ref="dropdownRef">
        <div class="relative">
            <button
                @click="toggleDropdown"
                class="w-full px-3 py-2 border rounded-lg text-sm sm:text-sm text-left bg-white flex justify-between items-center"
                :class="{ 'rounded-b-none': isOpen }"
            >
                <span>{{ displayValue }}</span>
                <svg class="w-4 h-4 ml-2 transition-transform" :class="{ 'rotate-180': isOpen }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
            </button>
        </div>
    </div>

    <div
        v-if="isOpen"
        ref="dropdownContainerRef"
        :style="dropdownStyle"
        class="bg-white border border-t-0 rounded-b-lg shadow-lg max-h-60 overflow-y-auto"
    >
        <div
            v-for="(item, index) in values"
            :key="item[labelKey]"
            @click="selectItem(item)"
            class="px-3 py-2 hover:bg-gray-100 cursor-pointer transition-colors"
            :class="{
                'bg-blue-50 text-blue-600': value === item,
                'border-t border-gray-100': index > 0
            }"
        >
            {{ item[labelKey] }}
        </div>
    </div>
</template>